import React, { Component, Fragment } from "react";
import { Tabs, Card } from "antd";
import "antd/dist/antd.css";
import "./singleTournament.css";

import goldTrophy from "../../style/images/home/profile dropdown/gold cup.png";
import silverTrophy from "../../style/images/home/profile dropdown/silver cup.png";
import bronzeTrophy from "../../style/images/home/profile dropdown/bronze cup.png";

import tempflag from "../../style/images/game/leaderboards/flags/Layer 38.png";
const TabPane = Tabs.TabPane;
export default class LeaderBoard extends Component {
  render() {
    return (
      <Fragment>
        <Card
          className="wow"
          title="Leaderboards"
          headStyle={{ textAlign: "right" }}
        >
          <Tabs
            defaultActiveKey="1"
            onChange={this.callback}
            type="card"
            tabBarStyle={{
              textAlign: "left",
              border: "transparent",
               backgroundColor: "#1e2341",
            }}
            style={{ color: "white" }}
          >
            <TabPane tab="TOP PLAYERS" key="1">
              <div className="row">
                <div className="col-xs-6">
                  {/* 1 */}
                  <div className="row">
                    <div className="col-xs-1 ">
                      {" "}
                      <img className="trophy" src={goldTrophy} />
                    </div>
                    <div className="col-xs-11">
                      <div
                        className="row "
                        style={{ backgroundColor: "#dabc51", paddingTop: "3%" }}
                      >
                        <div className="col-xs-1" />
                        <div className="col-xs-1">
                          <p className="ptext">
                            <b>1.</b>
                          </p>
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>player name</b>
                          </p>
                        </div>
                        <div className="col-xs-2">
                          <img src={tempflag} />
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>856,256 POINTS</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  {/* 2 */}
                  <div className="row">
                    <div className="col-xs-1 ">
                      {" "}
                      <img className="trophy" src={silverTrophy} />
                    </div>
                    <div className="col-xs-11">
                      <div
                        className="row "
                        style={{ backgroundColor: "#e5ecec", paddingTop: "3%" }}
                      >
                        <div className="col-xs-1" />
                        <div className="col-xs-1">
                          <p className="ptext">
                            <b>1.</b>
                          </p>
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>player name</b>
                          </p>
                        </div>
                        <div className="col-xs-2">
                          <img src={tempflag} />
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>856,256 POINTS</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  {/* 3 */}

                  <div className="row">
                    <div className="col-xs-1 ">
                      {" "}
                      <img className="trophy" src={bronzeTrophy} />
                    </div>
                    <div className="col-xs-11">
                      <div
                        className="row "
                        style={{ backgroundColor: "#eec6a0", paddingTop: "3%" }}
                      >
                        <div className="col-xs-1" />
                        <div className="col-xs-1">
                          <p className="ptext">
                            <b>1.</b>
                          </p>
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>player name</b>
                          </p>
                        </div>
                        <div className="col-xs-2">
                          <img src={tempflag} />
                        </div>
                        <div className="col-xs-4">
                          <p className="ptext">
                            <b>856,256 POINTS</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  {/* 4 */}

                  <div className="row">
                    <div className="col-xs-1 " />
                    <div className="col-xs-11">
                      <div
                        className="row "
                        style={{ backgroundColor: "#283160" }}
                      >
                        <div className="col-xs-1" />
                        <div className="col-xs-1 cold ">
                          <p className="ptextn">
                            <b>1.</b>
                          </p>
                        </div>
                        <div className="col-xs-4 cold">
                          <p className="ptextn">
                            <b>player name</b>
                          </p>
                        </div>
                        <div className="col-xs-2 ">
                          <img src={tempflag} style={{ width: "50%" }} />
                        </div>
                        <div className="col-xs-4 cold">
                          <p className="ptextn">
                            <b>856,256 POINTS</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-xs-6">
                
                </div> */}
              </div>
              <div class="showing">
                SHOWING 3 TOURNAMENTS OUT OF 347.{" "}
                <a className="underlineP" href="#">
                  VIEW ALL
                </a>
              </div>
            </TabPane>
            <TabPane tab="LUCKY WINNERS" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs>
        </Card>
      </Fragment>
    );
  }
}
